module.exports = __webpack_public_path__ + "img/Hero@3x.9abe8aa7.png";